import { render } from "./KontaktPthFerizaj.vue?vue&type=template&id=f05614c4"
import script from "./KontaktPthFerizaj.vue?vue&type=script&lang=js"
export * from "./KontaktPthFerizaj.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__